import React, { useState } from 'react'
import styles from './styles.module.css'
import Button from '../../../components/Button'
import { documents } from '../../../assets/svg/modalSVG'
import { Checkbox } from '../../../components/ModalInputs'

const Files = ({ lesson }) => {

  const [selectedPlan, setSelectedPlan] = useState([]);
  const [selectedHomeWork, setSelectedHomeWork] = useState([]);

  const plannerFiles = lesson?.planner_files || []
  const hwFiles = lesson?.hw_files || []

  const handleSelect = (type, index) => {
    if (type === 'plan') {
      if (selectedPlan.includes(index)) {
        setSelectedPlan(selectedPlan.filter(item => item !== index))
      } else {
        setSelectedPlan([...selectedPlan, index])
      }
    } else {
      if (selectedHomeWork.includes(index)) {
        setSelectedHomeWork(selectedHomeWork.filter(item => item !== index))
      } else {
        setSelectedHomeWork([...selectedHomeWork, index])
      }
    }
  }

  return (
    <div className={styles.wrapperFiles}>
      <div className={styles.planningFiles}>
        <h3 className={styles.filesTitle}>Планирование</h3>
        <div className={styles.files}>
          {plannerFiles.length > 0 ? (
            plannerFiles.map((fileName, index) => (
              <div className={styles.file} key={index}>
                <Checkbox onClick={() => handleSelect('plan', index)} /> {fileName} <i>{documents()}</i>
              </div>
            ))
          ) : (
            <div className={styles.emptyFiles}>Нет файлов</div>
          )}
        </div>
        <div className={styles.buttons}>
          <Button mode='white'>Добавить</Button>
          <Button mode='white' disabled={selectedPlan.length === 0}>Удалить</Button>
          <Button mode='white'>Скачать</Button>
          <Button mode='white' disabled={selectedPlan.length !== 1}>Просмотр</Button>
        </div>
      </div>

      <div className={styles.homeworkFiles}>
        <h3 className={styles.filesTitle}>Домашнее задание</h3>
        <div className={styles.files}>
          {hwFiles.length > 0 ? (
            hwFiles.map((fileName, index) => (
              <div className={styles.file} key={index}>
                <Checkbox onClick={() => handleSelect('homeWork', index)} /> {fileName} <i>{documents()}</i>
              </div>
            ))
          ) : (
            <div className={styles.emptyFiles}>Нет файлов</div>
          )}
        </div>
        <div className={styles.buttons}>
          <Button mode='white'>Добавить</Button>
          <Button mode='white' disabled={selectedHomeWork.length === 0}>Удалить</Button>
          <Button mode='white'>Скачать</Button>
          <Button mode='white' disabled={selectedHomeWork.length !== 1}>Просмотр</Button>
        </div>
      </div>

    </div>
  )
}

export default Files
